export class Others {
    _id: string;
    name: number;
    date: number;
    remarks: string;
}
